<template>
  <div>
      <div class="title">
        <img class="title-bg" :src="newsTitleBackground.location" />
        <div  class="page-wrapper title-wrapper">
          <img class="title-topic" :src="newsTitleTopic.location" />
          <label class="title-text page-wrapper">{{ $t('News.bulletinBoard') }}</label>
        </div>
      </div>
      <div class="content news-datail page-wrapper">
        <div class="content-title">{{ title }}</div>
        <div class="content-date">{{ date }}</div>
        <img v-if="refreshDom" class="title-topic1" :src="file['news' + id]" />
        <div class="content-detail" v-html="content"></div>
      </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from '@/api/config'
import { getNewsDetail } from '@/api/resourceAPI'
import { mapState, mapGetters } from 'vuex'

const NewsDetail = Vue.extend({
  name: 'NewsDetail',
  data: function () {
    return {
      content: '',
      bg: require('../../assets/News/titlebg.jpg'),
      title: this.$t('News.loading'),
      date: '',
      topic: require('../../assets/News/titlebg.jpg'),
      id: 0,
      refreshDom: true,
      fileId: [1005, 1006]
    }
  },
  components: {
  },
  computed: {
    ...mapState({
      file: state => state.resource.file,
      status: state => state.resource.status
    }),
    ...mapGetters({
      isFileChange: 'resource/size',
      newsTitleBackground: 'resource/newsTitleBackground',
      newsTitleTopic: 'resource/newsTitleTopic'
    })
  },
  watch: {
    isFileChange () {
      this.refresh()
    }
  },
  mounted () {
    this.id = this.$route.path.split('/')[3]
    for (let id of this.fileId) {
      console.log(id)
      if (!this.$store.state.resource.status[id]) {
        this.$store.dispatch('resource/getFileType', id)
      }
    }
    axios.get(getNewsDetail + this.id)
      .then((res) => {
        if (res.data.error === '01') {
          this.title = this.$t('News.newsNotExist')
        } else {
          this.content = res.data.data.content
          this.title = res.data.data.title
          this.date = res.data.data.valid_at
          this.$store.dispatch('resource/getFileSingle', { 'loc': res.data.data.image, 'name': 'news' + this.id })
          // this.$store.dispatch('resource/getFileList', this.fileId)
        }
      })
  },
  methods: {
    refresh () {
      this.refreshDom = false
      this.$nextTick(() => {
        this.refreshDom = true
      })
    }
  }
})
export default NewsDetail
</script>

<style scoped>
.title {
    margin: 0;
    height: 250px;
    overflow: hidden;
}
.title-bg {
    padding: 0;
    size: 1920px 250px;
    overflow: hidden;
}
.title-wrapper {
  height: 250px;
  /* transform: translateY(0px); */
  overflow: hidden;
}
.title-topic {
  max-width: 1024px;
  height: 250px;
  position: absolute;
  left: 50%;
  /* top: 60px; */
  transform: translate(-50%, 86px);
  overflow: hidden;
  top: 0;
}
.title-topic1 {
  overflow: hidden;
  max-height: 300px;
  max-width: 945px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.title-text {
    position: absolute;
    left: 50%;
    top: 90px;
    max-width: 80%;
    transform: translate(-50%, 80px);
    color: white;
    font-size: 3.5rem;
}
.news-datail {
    /* padding: 2%; */
    text-align: left;
    overflow: hidden;
}
.content-title {
    color: #428874;
    font-weight:700;
    font-size: 2rem;
    margin: 10px 0px;
}
.content-date {
    color: #999999;
    font-size: 1rem;
    margin: 10px 0px 15px 0px;
}
.content-detail {
    color: #444444;
    font-size: 20px;
}
</style>
